"use client";

import React from "react";

const items = [
  "Airlock Scheduling Engine",
  "Ghostwriter AI",
  "Elevate Brief",
  "Zero-Click Booking",
  "Long-Term Memory",
  "Gmail & Outlook",
  "Stress Heatmap",
  "Mobile-First",
  "AI Triage",
  "Haptic UX",
];

const MarqueeBar: React.FC = () => {
  const doubled = [...items, ...items];

  return (
    <div
      className="relative overflow-hidden py-4"
      style={{
        borderTop: "1px solid rgba(255,255,255,0.05)",
        borderBottom: "1px solid rgba(255,255,255,0.05)",
        background: "rgba(255,255,255,0.01)",
      }}
    >
      {/* Left fade */}
      <div
        className="absolute left-0 top-0 bottom-0 w-24 z-10 pointer-events-none"
        style={{ background: "linear-gradient(to right, #0D0F14, transparent)" }}
      />
      {/* Right fade */}
      <div
        className="absolute right-0 top-0 bottom-0 w-24 z-10 pointer-events-none"
        style={{ background: "linear-gradient(to left, #0D0F14, transparent)" }}
      />

      <div className="marquee-track items-center gap-12">
        {doubled.map((item, i) => (
          <span key={`${item}-${i}`} className="flex items-center gap-12 shrink-0">
            <span
              className="text-sm font-medium uppercase tracking-widest"
              style={{ color: "#5C5A56", letterSpacing: "0.15em" }}
            >
              {item}
            </span>
            <span style={{ color: "#F59E0B", fontSize: "8px" }}>◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default MarqueeBar;